import { MutableRefObject, useState } from 'react';
import { Button, Modal, Typography } from '@la/ds-ui-components';
import { Division } from '@la/types';
import { getSubProgramLabelPlural } from '@la/utilities';
import * as S from './DivisionsModal.styles';

type DivisionModalProps = {
  divisions: Division[];
  refs: Map<string, MutableRefObject<HTMLElement | null>>;
  subProgramLabel: string;
};

export function DivisionsModal({
  divisions,
  refs,
  subProgramLabel,
}: DivisionModalProps) {
  const [isModalDivisionsOpen, setIsDivisionsModalOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setIsDivisionsModalOpen(true)}>
        View divisions
      </Button>
      <Modal
        open={isModalDivisionsOpen}
        title={`Tournament ${getSubProgramLabelPlural(subProgramLabel)}`}
        onOpenChange={() => setIsDivisionsModalOpen(false)}
      >
        <main>
          <section>
            {divisions.map((division) => (
              <S.SideMenuItemContainer
                key={`${subProgramLabel}-modal-item-${division.id}`}
                onClick={() => {
                  setIsDivisionsModalOpen(false);
                  refs.get(division.id)?.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                  });
                }}
              >
                <Typography
                  key={`${subProgramLabel}-modal-item-${division.id}`}
                  size="large"
                  variant="ui"
                  weight="regular"
                >
                  {division.name}
                </Typography>
              </S.SideMenuItemContainer>
            ))}
          </section>
        </main>
      </Modal>
    </>
  );
}
